import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import { CkeditorConstants } from '../../src/utils/ckeditorconstants';
import DeleteInBatchByIdCommand from './deleteinbatchbyidcommand';

const {
  command: { DELETE_IN_BATCH_BY_ID } } = CkeditorConstants;

export default class DeleteInBatchByIdEditing extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add(
      DELETE_IN_BATCH_BY_ID,
      new DeleteInBatchByIdCommand(editor)
    );
    const trackChangesEditing = editor.plugins.get('TrackChangesEditing');

    trackChangesEditing.descriptionFactory.registerDescriptionCallback(
      (suggestion) => {
        const { attributes } = suggestion;
        if (
          !attributes ||
          attributes.commandName !==
          CkeditorConstants.command.DELETE_IN_BATCH_BY_ID
        ) {
          return;
        }

        const content = `*Remove link:* ${attributes.commandParams.linkAddress}`;
        return {
          type: 'deletion',
          content
        };
      }
    );
  }
}
